export { ProviderList } from './providers/ProviderList';

export const meta = {
  label: 'Providers',
  order: 30,
  section: 'User Lookup',
};
